import React from "react";
import { NotImplemented } from "pages/PayRoll/Shared/NotImplemented";

// Placeholder until Disbursement Configuration is built. Reached from
// Payroll > Configuration > Disbursement Configuration in the sidebar flyout.
export const ConfigDisbursementConfiguration = () => <NotImplemented title="Disbursement Configuration" />;
